import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useBrandColors, applyBrandColors, removeBrandColors } from '@/hooks/useBrandColors';

const PUBLIC_ROUTES = ['/', '/demo', '/demo-spotlight', '/login', '/signup', '/select-plan', '/privacy', '/terms'];

export function BrandColorProvider({ children }: { children: React.ReactNode }) {
  const { colors, loading } = useBrandColors();
  const location = useLocation();

  useEffect(() => {
    const isPublicRoute = PUBLIC_ROUTES.some(route => 
      location.pathname === route
    ) || location.pathname.startsWith('/north/')
       || location.pathname.startsWith('/spotlight/')
       || location.pathname.startsWith('/s/')
       || location.pathname.startsWith('/privacy-')
       || location.pathname.startsWith('/terms-');

    // Always remove brand colors first to ensure clean state
    // Then apply them only if needed (on authenticated non-public routes)
    if (isPublicRoute) {
      // Remove brand colors on public routes (use landing page theme)
      removeBrandColors();
    } else {
      // For authenticated routes, wait for colors to load before applying
      // This prevents showing stale brand colors from previous session
      if (!loading) {
        if (colors) {
          // Apply user's brand colors on authenticated routes
          applyBrandColors(colors);
        } else {
          // No brand colors set - ensure defaults are used
          removeBrandColors();
        }
      }
    }

    // Cleanup on unmount
    return () => {
      if (!isPublicRoute) {
        removeBrandColors();
      }
    };
  }, [colors, loading, location.pathname]);

  return <>{children}</>;
}
